<template>
  <v-toolbar dense
             flat
             grow
             class="mb-4 transparent">
    <v-tabs class="mb-4">
      <v-tab :to="{name: 'admin.user.show', params: {userID: user.id}}"
             exact>
        Profile
      </v-tab>
      <v-tab :to="{name: 'admin.user.edit', params: {userID: user.id}}"
             v-if="isAdmin">
        Edit
      </v-tab>
      <!--<v-tab>
        Dashboard
      </v-tab>-->
      <!--<v-tab>
        Activity
      </v-tab>-->
      <v-tab :to="{name: 'change_password'}"
             v-if="isCurrentUser">
        Change Password
      </v-tab>
      <!--<v-tab>
        API Tokens
      </v-tab>-->
      <v-tab :to="{name: 'admin.user.connections', params: {userID: user.id}}"
             v-if="isAdmin || isCurrentUser">
        Connections
      </v-tab>
      <v-tab :to="{name: 'admin.user.teams', params: {userID: user.id}}"
             v-if="isSuperAdmin">
        Teams
      </v-tab>

    </v-tabs>
  </v-toolbar>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'isAdmin',
      'isSuperAdmin',
    ]),
    isCurrentUser() {
      return this.user.id === this.currentUser.id;
    }
  }
}
</script>
